import { useEffect, useState } from "react";

const MOBILE_MAX_WIDTH_PX = 768;

/**
 * True when viewport width is at or below the mobile breakpoint.
 * Used for V1 desktop-only gate (see MobileDesktopOnlyGate).
 */
export function useIsMobileViewport(maxWidthPx = MOBILE_MAX_WIDTH_PX) {
  const query = `(max-width: ${maxWidthPx}px)`;
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    const media = window.matchMedia(query);
    const onChange = (event) => setIsMobile(event.matches);
    setIsMobile(media.matches);
    media.addEventListener("change", onChange);
    return () => media.removeEventListener("change", onChange);
  }, [query]);

  return isMobile;
}

export { MOBILE_MAX_WIDTH_PX };
